import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class StorageService { // service permettant de gérer le contenu du localStorage. Les clés et les valeurs stockées seront chiffrées avec une clé de chiffrement pour plus de sécurité.

  secretKey = '6e5rr8g425d69f36r8956f236g54dfr5'; // clé de chiffrement
  constructor() { }

  // Chiffrement AES-CBC avec IV aléatoire par appel (l'IV n'est pas secret,
  // il est stocké en clair avec le message chiffré, comme il se doit).
  encrypt(value: string): string {
    const key = CryptoJS.enc.Utf8.parse(this.secretKey);
    const iv = CryptoJS.lib.WordArray.random(16);
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
      {
        keySize: 256 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return iv.toString(CryptoJS.enc.Base64) + ':' + encrypted.toString();
  }

  decrypt(textToDecrypt: string): string {
    const [ivB64, cipherText] = textToDecrypt.split(':');
    if (!ivB64 || !cipherText) {
      return '';
    }
    const key = CryptoJS.enc.Utf8.parse(this.secretKey);
    const iv = CryptoJS.enc.Base64.parse(ivB64);
    const decrypted = CryptoJS.AES.decrypt(cipherText, key, {
      keySize: 256 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  // Hash déterministe utilisé uniquement pour le nom de la clé localStorage :
  // contrairement à encrypt(), il doit retourner la même valeur à chaque appel
  // pour un même "key" afin que get() retrouve l'entrée posée par set().
  private hashKey(key: string): string {
    return CryptoJS.SHA256(key).toString();
  }

  set<T>(key: string, value: any) {
    // json stringify value
    value = JSON.stringify(value);
    // Le nom de la clé est haché (déterministe) et la valeur est chiffrée pour plus de sécurité.
    const hashedKey = this.hashKey(key);
    const encryptedValue = this.encrypt(value);
    localStorage.setItem(hashedKey, encryptedValue);
  }

  get<T>(key: string, defaultValue: any = null) {
  const hashedKey = this.hashKey(key);
  const encryptedValue = localStorage.getItem(hashedKey);
  if (encryptedValue) {
    const json = this.decrypt(encryptedValue);
    try {
      return JSON.parse(json);
    } catch (e) {
      console.error('Erreur JSON', e);
      return defaultValue;
    }
  } else {
    return defaultValue;
  }
}


  clearAll() {
    localStorage.clear()
  }
}
